// extracted by mini-css-extract-plugin
export default {"component":"qBXVt","item":"uHpRA","carousel":"BYUiH"};